import {
  DoublePost,
  SelectableIntermediatePost,
  TerminationPost,
  Post,
  SingleCornerPost,
  SelectablePicket
} from './object3D';
import { common } from './common';
import { Injectable } from '@angular/core';
import { DataForDisplayingMenuItemsService } from '../data-for-displaying-menu-items.service';
import { Edge } from '../railing';
import { DrawingsHolderService } from './drawings-holder.service';
import { IntermediatePost } from './object3D/Post/IntermediatePost';

declare const THREE: any;

@Injectable()
export class PostFactoryService {
  constructor(
    private state: DataForDisplayingMenuItemsService,
    private drawings: DrawingsHolderService
  ) { }

  private static calculateEdgeForDC(edge: Feeney.IEdge) {
    const offset = 22;

    const start = edge.start;
    start.add(edge.direction.multiplyScalar(offset));

    const end = edge.end;
    end.add(edge.direction.negate().multiplyScalar(offset));

    return new Edge(start, end);
  }

  create(
    postInfo: Feeney.IPost,
    edge: Feeney.IEdge,
    scaleCor?,
    createdCallback?: (post: any) => any
  ): Post {
    let post;

    const isSingleCorner = this.state.currentChoises.cornerPosts === 'Single';

    const is90 =
      // postInfo.non90 === undefined || postInfo.non90 === false;
      Math.round(Math.abs(THREE.Math.radToDeg(postInfo.rotation))) % 90 === 0;

    const singleOrNon90 =
      isSingleCorner || !is90 || postInfo.non90 || postInfo.is45 || postInfo.is135; // || postInfo.not90;

    if (postInfo.corner && singleOrNon90 && !postInfo.isTerminationPost) {
      const im = new THREE.ImageLoader().load('assets/images/scene-plan/sc.png', im => {
        post = new SingleCornerPost({ postType: 'SC', labelPosition: 'Center' }, im);

        post.position.set(postInfo.x, 0, postInfo.z);
        post.rotation.y = postInfo.rotation;

        post.update();
        post.children
          .filter(ch => ch.name === 'text')
          .forEach(ch => {
            ch.rotation.y -= post.rotation.y;
          });
        post.setLabelPos();
        this.drawings.canvas.add(post);
        if (createdCallback) createdCallback(post);
      });
    } else if (postInfo.isTerminationPost) {
      post = new TerminationPost();
      post.position.set(postInfo.x, 0, postInfo.z);
      post.rotation.y = postInfo.rotation;

      post.update();
      this.drawings.canvas.add(post);
      if (createdCallback) createdCallback(post);
    } else if (postInfo.corner) {
      const im = new THREE.ImageLoader().load('assets/images/scene-plan/c.png', im => {
        post = new DoublePost(im);

        post.position.set(postInfo.x, 0, postInfo.z);
        post.rotation.y = postInfo.rotation;

        post.update();
        post.children
          .filter(ch => ch.name === 'text')
          .forEach(ch => {
            ch.rotation.y -= post.rotation.y;
          });
        this.drawings.canvas.add(post);
        if (createdCallback) createdCallback(post);
      });
    } else {
      //  const newEdge = singleOrNon90 ? edge : PostFactoryService.calculateEdgeForDC(edge);
      const im = new THREE.ImageLoader().load('assets/images/scene-plan/in.png', im => {
        post = new SelectableIntermediatePost(edge, im);

        post.position.set(postInfo.x, 0, postInfo.z);
        post.rotation.y = postInfo.rotation;
        post.scaleCor = scaleCor ? scaleCor : 1;
        post.update();
        post.children
          .filter(ch => ch.name === IntermediatePost.Name)
          .forEach(ch => {
            ch.children
              .filter(c => c.name === 'text')
              .forEach(c => {
                c.rotation.y -= post.rotation.y;
              });
          });
        this.drawings.canvas.add(post);
        if (createdCallback) createdCallback(post);
      });
    }

    return post;
  }

  createPicket(picketInfo: Feeney.IPicket, edge?: Feeney.IEdge, type?: string, labelPos?: string) {
    let picket;
    if (edge) {
      picket = new SelectablePicket(edge);
    } else {
      picket = new SelectablePicket();
    }

    if (!type) {
      type = "PK";
    }
    picket.position.set(picketInfo.x, 0, picketInfo.z);

    picket.labelPos = labelPos;
    const im = new THREE.ImageLoader().load('assets/images/scene-plan/' + type.toLowerCase() + '.png',
      im => {
        picket.addLabel({postType: type, labelPosition: picket.labelPos}, im);
      });

    return picket;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/proTools/post-factory.service.ts